import "./page-header.css";
import React from "react";
import { NavLink } from "react-router-dom";
import { Auth, useAuth } from "./auth/AuthContext";

const PageHeader = (): JSX.Element => {
   const auth: Auth = useAuth();
   if (auth?.user == null) {
      return <></>;
   }

   const htmlId = (suffix?: string): string => {
      const prefix = "page-header";
      return suffix ? prefix + "_" + suffix : prefix;
   };
   return (
      <div id={htmlId()}>
         <h3>
            <span id={htmlId("username")}>{auth.user.username}</span>
            <button id={htmlId("log-out")} type="button" className="link" onClick={auth.logout}>
               log out
            </button>
         </h3>
         <nav id={htmlId("tabs")}>
            {auth?.user?.permissions?.instance?.canView && (
               <NavLink to="/instances" id={htmlId("tab-instances")}>Instances</NavLink>
            )}
            {auth?.user?.permissions?.licence?.canView && (
               <>
                  <NavLink to="/licences" id={htmlId("tab-licences")}>Licences</NavLink>
                  <NavLink to="/report" id={htmlId("tab-reports")}>Reports</NavLink>
               </>
            )}
         </nav>
      </div>
   );
};

export default PageHeader;
